var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlinereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(1.5 1.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.086 9.156c-.68133-.672-1.022-1.65667-1.022-2.954v-6.202h1.876v6.062c0 .924.15867 1.58667.476 1.988s.84933.602 1.596.602c.364 0 .68133-.042.952-.126.27067-.09333.49467-.24267.672-.448.18667-.21467.322-.49467.406-.84.09333-.34533.14-.77933.14-1.302v-5.936h1.876v6.09c0 1.316-.34533 2.324-1.036 3.024-.68133.6907-1.68933 1.036-3.024 1.036-1.26 0-2.23067-.3313-2.912-.994z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.41h10.178v.7h-10.178z"
  }))));
}
export default SvgUnderlinereact;